import React from 'react';
import './Creator.css';
import creatorImage from '../../images/joan img.jpg'

const Creator = () => {
  return (
    <section className="creator" data-aos="fade-up">
      <div className="container">
        <div className="creator__grid">
          <div className="creator__image" data-aos="zoom-in" data-aos-delay="200">
            <img 
              src={creatorImage} 
              alt="Creator of the game" 
              className="creator__photo"
            />
          </div>
          <div className="creator__content" data-aos="fade-left" data-aos-delay="400">
            <h2 className="creator__title">Creator of the Game</h2>
            <p className="creator__text">
              CyberLingo was founded by Joan Uzoamaka Nwafor, a Cybersecurity Consultant, Community Builder, and GRC (Governance, Risk & Compliance) Advocate passionate about making cybersecurity accessible to everyone.
            </p>
            <p className="creator__text">
              Through her initiative CyberTalkswithJojo, Joan has reached thousands globally—bridging awareness, mentorship, and innovation in the cyber space.

              With CyberLingo, she aims to turn cybersecurity awareness into a household conversation, one card at a time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Creator;